import { ObjectType, PatternType } from "../../../../contexts/types/card";
import ElaboratorsAndInstitutions from "../../shared/ElaboratorsAndInstitutions/elaboratorsAndInstitutions";
import CardCompletionDate from "../components/cardCompletionDate";
import DeterminationDate from "../components/determinationDate";
import Location from "../components/location";
import MainCriterionForArea from "../components/mainCriterionForArea";
import ObservationInstructions from "../components/observationInstructions";
import RegistrationNumber from "../components/registrationNumber";
import { FormContextProps } from "../components/shared/types/formContextProps";
import { FormSectionProps } from "../components/shared/types/formSectionProps";

const KrFormEndangeredArea = (props: FormContextProps) => {
    const objectType = ObjectType.KRTZ;
    const version = props.context.endangeredAreaAttributes?.wersjA_KARTY;
    const is2007 = version === PatternType.P2007;
    const elaboratorsSectionTitle = is2007 ? <>
        <h2>4. Autor karty</h2>
        <h2>5. Kategoria i numer uprawnień geologicznych</h2>
        <h2>6. Instytucja</h2>
    </> : <>
        <h2>5. Wypełniający kartę</h2>
        <h2>6. Kategoria i numer kwalifikacji geologicznych</h2>
        <h2>7. Instytucja</h2>
    </>;

    var formSectionProps: FormSectionProps = {
        editMode: props.editMode,
        objectType: objectType,
        version: version,
        getMapForNavScroll: props.getMapForNavScroll,
        getMapForComment: props.getMapForComment,
        setNewCommentFieldDetails: props.setNewCommentFieldDetails,
        setCommentsFilter: props.setCommentsFilter,
        markedFieldForCommentFiltering: props.markedFieldForCommentFiltering,
    }

    return (<>
        <div className="krFormSection-grid"><RegistrationNumber {...formSectionProps}/></div>
        {!is2007 && <div className="krFormSection-flex"><Location {...formSectionProps}/></div>}
        <div className="krFormSection-flex"><MainCriterionForArea {...formSectionProps}/></div>
        <div className="krFormSection-flex"><ObservationInstructions {...formSectionProps}/></div>
        <div className="krFormSection-flex"><ElaboratorsAndInstitutions {...formSectionProps} sectionTitle={elaboratorsSectionTitle} context={props.context} setContext={props.setContext} isKR={true} /></div>
        {!is2007 && <div className="krFormSection-flex"><DeterminationDate {...formSectionProps}/></div>}
        <div className="krFormSection-flex"><CardCompletionDate {...formSectionProps}/></div>
    </>)
}
export default KrFormEndangeredArea;